/* eslint-disable */

import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import axios from "axios";
import apiInstance from "../../../utils/api";
import Swal from "sweetalert2";

const DeleteDialog = (props) => {
    const { filterList, setFilterList } = props
    console.log(props, 'id')
    const [isShow, setIsShow] = useState(true);
    const [code, setCode] = useState('')


    const handleDelete = () => {
        // console.log(event, "event");
        props.setOpen(false);
        if (code === 'WinClinicAdmin123@') {
            apiInstance
                .delete(
                    "voucher/" +
                    props.id
                )
                .then((response) => {
                    Swal.fire({
                        title: "Success",
                        text: "Successfully Deleted!",
                        icon: "success",
                        showConfirmButton: false,
                        timer: 3000
                    });
                    const result = filterList.filter((item) => item._id !== props.id);
                    setFilterList(result);
                })
                .catch((error) => {
                    Swal.fire({
                        title: "Error",
                        text: error.response.data.message,
                        icon: "error",
                        showConfirmButton: false,
                        timer: 3000
                    });
                });
        } else {
            Swal.fire({
                title: "Your code is Wrong",
                text: 'Try again!',
                icon: "error",
                showConfirmButton: false,
                timer: 3000
            });
        }

    };


    return (
        <div >
            {isShow && (
                <Dialog open={props.open} onClose={props.close} fullWidth maxWidth='sm'>
                    <DialogTitle className="bg-red">
                        Delete Conrifm
                    </DialogTitle>
                    <DialogContent>

                        <div className='d-flex flex-column p-2'>
                            <label>Code</label>
                            <input type='text' placeholder="Type code" className='p-2 rounded-lg border-light' onChange={(e) => setCode(e.target.value)} />
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={props.close} className=' text-red'>Cancel</Button>
                        <Button className='bg-blue' onClick={handleDelete}>Delete</Button>
                    </DialogActions>
                </Dialog>
            )}
        </div>
    );
};

export default DeleteDialog;
